/*global jQuery */
//
// Description: lazyload background image
// Dependencies: jquery.scrollcontrol.js
// Author: Kim Christiansen
//
( function ($, window) {
  'use strict';

  var $window,
      $document,
      $scope,
      setup = function () {

        $scope.on('scrollcontrol/isViewed', function (e) {
          // console.log('lazyimage: scrollcontrol/isViewed');
          loadImage($(this));
        });

      },
      loadImage = function($bgimage) {
        var href = $bgimage.data('lazybgimage-src');

        if( href ) {
          // console.log('load bg image: ' + href);

          var largeImage = new Image();
          largeImage.src = href;
          if (largeImage.complete) {
            replaceBgImage($bgimage, largeImage);
          } else {
            largeImage.onload = function(){replaceBgImage($bgimage, largeImage);};
          }
        } else {
          console.warn('no href in Lazybgimage');
        }
      },
      replaceBgImage = function($bgimage, largeImage) {
        // console.log('addBgImage');
        // console.log($bgimage);
        // console.log(largeImage);

        var href = $bgimage.data('lazybgimage-src');

        // console.log('replace bgimage with ' + href);

        $bgimage.addClass('is-revealing');
        $bgimage.css('background-image','url("'+href+'")');


        $($bgimage).on('animationend', function(e){
          // console.log('animation end');
          $bgimage.removeClass('is-notReplaced');
          $bgimage.removeClass('is-revealing');
        });

        $bgimage.triggerHandler('lazybgimage/imageLoaded');

      },
      init = function () {
        $window = $(window);
        $document = $(document);

        $scope = $('.js-lazybgimage');
        if( $scope.length ) {
          setup();
        }

      };

  init();
}(jQuery, window));
